import { get, map } from 'lodash/fp';

interface Identified {
    id: number | string;
}

export const getCollectionIds = <T extends Identified>(items: Array<T>) => map<T, T['id']>(get('id'), items);
